// extracted by mini-css-extract-plugin
export var divider = "_s4-0";
export var systemMessage = "_s4-1";
export var systemMessageWrapper = "_s4-2";